import PriceSummary from "./Components/PriceSummary";
import "./CheckOutStep.scss";
import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import { getAllCountries } from "../../../services/getAllCountries";
import { getBillingAddress } from "../../../services/getBillingAddress";
import { getPaymentSession } from "../../../services/paymentSession";

const BillingStep = ({ data, setData, next, back, total,setClientSecret  }) => {
  const [countries, setCountries] = useState([]);
  const studentId=localStorage.getItem("studentId");
   const [loading, setLoading] = useState(false);
  const [validations, setValidations] = useState({
    name: true,
    address: true,
    postalCode: true,
    city: true,
    country: true,
    state: true,
  });

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await getAllCountries();
        setCountries(res.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchSavedAddress = async () => {
      try {
        const res = await getBillingAddress(studentId);
          const address = res.data; 
          setData((prev) => ({
            ...prev,
            billing: {
              name: address.name || "",
              address: address.address || "",
              city: address.city || "",
              postalCode: address.postalCode || "",
              country: address.countryId || "",
              state: address.state || "",
            },
          }));

          setValidations({
            name: true,
            address: true,
            postalCode: true,
            city: true,
            country: true,
            state: true,
          });
        
      } catch (error) {
        console.error("Error fetching saved address:", error);
      }
    };

    fetchSavedAddress();
  }, [setData]);

  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      billing: {
        ...prev.billing,
        [name]: value,
      },
    }));

    setValidations((prev) => ({
      ...prev,
      [name]: value.trim() !== "",
    }));
  };

  const isFormValid =
    Object.values(validations).every((v) => v === true) &&
    data.billing?.name &&
    data.billing?.address &&
    data.billing?.postalCode &&
    data.billing?.city &&
    data.billing?.state &&
    data.billing?.country;

 const handleNext = async () => {
  const newValidations = {
    name: data.billing?.name?.trim() !== "",
    address: data.billing?.address?.trim() !== "",
    postalCode: data.billing?.postalCode?.trim() !== "",
    city: data.billing?.city?.trim() !== "",
    country: data.billing?.country?.trim() !== "",
    state: data.billing?.state?.trim() !== "",
  };

  setValidations(newValidations);

  if (!Object.values(newValidations).every((v) => v)) return;

  const token = localStorage.getItem("token");

  try {
    setLoading(true);

    const res = await getPaymentSession({ data, token });

    if (res?.isSuccess) {
      setClientSecret(res.clientSecret); // 👈 important for Stripe
      next(); // move to payment step
    }
  } catch (error) {
    console.error("Session error:", error);
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="checkout-content">
      <Form>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                id="name"
                name="name"
                type="text"
                placeholder="Name"
                value={data.billing?.name || ""}
                onChange={handleChange}
                invalid={!validations.name}
              />
              {!validations.name && (
                <FormFeedback className="fs-5">
                  Name is required
                </FormFeedback>
              )}
            </FormGroup>
          </Col>

          <Col md={12}>
            <FormGroup>
              <Label for="address">Address</Label>
              <Input
                id="address"
                name="address"
                placeholder="Address"
                type="textarea"
                value={data.billing?.address || ""}
                onChange={handleChange}
                invalid={!validations.address}
              />
              {!validations.address && (
                <FormFeedback className="fs-5">
                  Address is required
                </FormFeedback>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label for="country">Country</Label>
              <Input
                id="country"
                name="country"
                type="select"
                value={data.billing?.country || ""}
                onChange={handleChange}
                invalid={!validations.country}
              >
                <option value="">-- Please select country --</option>
                {countries.map((country) => (
                  <option key={country.countryCode} value={country._id}>
                    {country.countryName}
                  </option>
                ))}
              </Input>
              {!validations.country && (
                <FormFeedback className="fs-5">
                  Country is required
                </FormFeedback>
              )}
            </FormGroup>
          </Col>


            <Col md={6}>
            <FormGroup>
              <Label for="state">Sate</Label>
              <Input
                id="state"
                name="state"
                type="text"
                placeholder="state"
                value={data.billing?.state || ""}
                onChange={handleChange}
                invalid={!validations.state}
              />
              {!validations.state && (
                <FormFeedback className="fs-5">
                  State is required
                </FormFeedback>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label for="city">City</Label>
              <Input
                id="city"
                name="city"
                type="text"
                placeholder="City"
                value={data.billing?.city || ""}
                onChange={handleChange}
                invalid={!validations.city}
              />
              {!validations.city && (
                <FormFeedback className="fs-5">
                  City is required
                </FormFeedback>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label for="postalCode">Postal Code</Label>
              <Input
                id="postalCode"
                name="postalCode"
                type="text"
                placeholder="Postal Code"
                value={data.billing?.postalCode || ""}
                onChange={handleChange}
                invalid={!validations.postalCode}
              />
              {!validations.postalCode && (
                <FormFeedback className="fs-5">
                  Postal Code is required
                </FormFeedback>
              )}
            </FormGroup>
          </Col>
        </Row>
      </Form>
      <PriceSummary
        price={data.price}
        discount={data.discount}
        total={total}
     onNext={handleNext}
  nextDisabled={!isFormValid || loading}
      />
    </div>
  );
};

export default BillingStep;